import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#888888",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_30074_6165)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00071 11.889C10.1485 11.889 11.8896 10.1479 11.8896 8.00016C11.8896 5.85238 10.1485 4.11127 8.00071 4.11127C5.85293 4.11127 4.11182 5.85238 4.11182 8.00016C4.11182 10.1479 5.85293 11.889 8.00071 11.889Z",
					stroke: "#556C32",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 9.55562V8.00006",
					stroke: "#556C32",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 6.44458H8.00413",
					stroke: "#556C32",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_30074_6165",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9.33333,
				height: 9.33333,
				fill: "white",
				transform: "translate(3.3335 3.33331)"
			})
		}) })
	]
});
export default SvgMinorIcon;
